import useGroups from "@/hooks/useGroups";
import { colors } from "@/utils/constants/colors";
import { Button, Stack } from "@mui/material";

const CreateGroup = () => {
  const { createGroup, groups } = useGroups();

  const nbGroup = groups.length;

  const getNewGroupColor = () => colors[nbGroup + 1];

  const handleAddGroup = () => {
    createGroup(getNewGroupColor());
  };

  return (
    <Stack alignItems="end">
      <Button
        disabled={nbGroup >= colors.length}
        onClick={handleAddGroup}
        color="primary"
        variant="contained"
        sx={{
          borderRadius: 2,
          width: "fit-content",
          "& :hover": {
            background: (theme: ThemeType) => theme.palette.tertiary.main,
          },
        }}>
        Ajouter un groupe
      </Button>
    </Stack>
  );
};

export default CreateGroup;
